import { AfterViewInit, Component, HostListener, ViewEncapsulation } from '@angular/core';
import { isTargetClickable, setWhiteBackgroundIfNothingSet } from '@modules/cursors/helpers/helpers';

@Component({
  selector: 'app-circle-cursor',
  template: `
    <div class="cursor">
      <div class="cursor__ball cursor__ball--big"></div>
      <div class="cursor__ball cursor__ball--small"></div>
    </div>`,
  styles: [`
    body, body * {
      cursor: none !important;
    }

    app-cursors-wrapper {
      mix-blend-mode: difference;
    }

    .cursor {
      pointer-events: none;
    }

    .cursor__ball {
      position: fixed;
      top: 0;
      left: 0;
      mix-blend-mode: difference;
      z-index: 1000;
      background: #f7f8fa;
      border-radius: 50%;
    }

    .cursor__ball--small {
      transition-duration: 0s !important;
      width: 10px;
      height: 10px;
    }

    .cursor__ball--big {
      transition-duration: 0.1s !important;
      width: 30px;
      height: 30px;
    }
  `],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class CircleCursorComponent implements AfterViewInit {
  private ball: HTMLElement;
  private smallBall: HTMLElement;
  private mouseX = 0;
  private mouseY = 0;
  private ballX = 0;
  private ballY = 0;
  private smallBallX = 0;
  private smallBallY = 0;
  isBig = false;

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(e: any): void {
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
    this.isBig = isTargetClickable(e.target);
  }

  ngAfterViewInit(): void {
    setWhiteBackgroundIfNothingSet();
    this.ball = document.querySelector('.cursor__ball--big') as HTMLElement;
    this.smallBall = document.querySelector('.cursor__ball--small') as HTMLElement;

    requestAnimationFrame(() => this.animate());
  }

  private animate(): void {
    this.ballX += (this.mouseX - this.ballX) * 0.1;
    this.ballY += (this.mouseY - this.ballY) * 0.1;
    this.smallBallX += (this.mouseX - this.smallBallX) * 0.4;
    this.smallBallY += (this.mouseY - this.smallBallY) * 0.4;

    if (this.ball && this.smallBall) {
      const ballTranslate = `translate(${this.ballX - 15}px, ${this.ballY - 15}px)`;
      const ballScale = this.isBig ? ' scale(4)' : '';
      this.ball.style.transform = ballTranslate + ballScale;
      this.smallBall.style.transform = `translate(${this.smallBallX - 5}px, ${this.smallBallY - 5}px)`;
    }

    requestAnimationFrame(() => this.animate());
  }

}
